module.exports = __webpack_public_path__ + "img/behind-the-waves.4c528538.jpg";